var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrocery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 4.3125H24.4375V6.46875H18.6875V4.3125Z",
    fill: "url(#paint0_linear_0_3687)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1821 22.7604C28.3859 22.7604 28.3859 20.8438 26.5898 20.8438C24.7936 20.8438 24.7936 22.7604 22.9974 22.7604C21.2012 22.7604 21.2007 20.8438 19.4041 20.8438C17.6074 20.8438 17.6084 22.7604 15.8128 22.7604C14.0155 22.7604 14.0155 20.8438 12.2183 20.8438C10.4198 20.8438 10.4198 22.7604 8.62133 22.7604C6.82287 22.7604 6.82287 20.8438 5.02441 20.8438V43.125H33.0557V20.9727C31.9383 21.3983 31.6984 22.7604 30.1821 22.7604Z",
    fill: "url(#paint1_linear_0_3687)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3722 22.7604C35.8536 22.7604 35.6137 21.3977 34.4941 20.9724V43.125H40.9692V20.8438C39.1707 20.8438 39.1707 22.7604 37.3722 22.7604Z",
    fill: "url(#paint2_linear_0_3687)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8132 21.3228C16.0462 21.3228 16.1227 21.2856 16.5594 20.8192C16.8924 20.3801 17.3226 20.0241 17.8162 19.779C18.3097 19.5339 18.8533 19.4063 19.4044 19.4063C19.9555 19.4062 20.4992 19.5337 20.9928 19.7788C21.4864 20.0238 21.9166 20.3798 22.2497 20.8188C22.6833 21.2818 22.7635 21.3219 22.9928 21.3224C22.7386 19.8407 22.8142 18.3212 23.2141 16.872C23.6964 14.8889 24.8039 13.1136 26.3728 11.8083C25.6539 11.0067 24.7395 10.4052 23.7188 10.0625V7.90625H19.4062V10.0625C18.1505 10.4811 17.0582 11.2842 16.2842 12.3581C15.5102 13.4319 15.0937 14.7221 15.0938 16.0458V20.8489C15.4835 21.2626 15.5753 21.3228 15.8132 21.3228Z",
    fill: "url(#paint3_linear_0_3687)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6217 20.8184C37.0415 21.2663 37.1257 21.3228 37.3714 21.3228C37.6171 21.3228 37.702 21.2663 38.1224 20.8181C38.2693 20.6615 38.4405 20.4829 38.6392 20.3062C39.2645 17.1037 38.1497 14.1772 35.996 13.6003C35.2216 13.4114 34.4048 13.5124 33.6997 13.8842C33.8169 13.1522 34.1727 12.4794 34.7119 11.9705C34.9841 11.7643 35.2974 11.6188 35.6306 11.5437C35.9637 11.4687 36.3091 11.4658 36.6435 11.5353C36.7378 11.5498 36.8341 11.5454 36.9267 11.5223C37.0192 11.4992 37.1063 11.4579 37.1827 11.4008C37.2592 11.3437 37.3235 11.272 37.3719 11.1898C37.4204 11.1075 37.4519 11.0165 37.4648 10.922C37.4777 10.8274 37.4716 10.7313 37.447 10.6391C37.4223 10.5469 37.3795 10.4606 37.3211 10.3851C37.2627 10.3097 37.1899 10.2466 37.1069 10.1995C37.0239 10.1525 36.9323 10.1225 36.8376 10.1112C36.3074 10.0128 35.7623 10.0285 35.2387 10.1574C34.7151 10.2863 34.225 10.5254 33.8011 10.8587C33.0214 11.5593 32.4953 12.4981 32.3046 13.5288C31.8795 12.8433 31.2163 12.339 30.4422 12.1125C28.1416 11.496 25.5271 13.7938 24.6024 17.2444C24.3336 18.2298 24.2324 19.2535 24.3031 20.2725C24.9278 19.7038 25.7454 19.3941 26.5901 19.4062C27.14 19.4129 27.6813 19.5433 28.1738 19.7879C28.6664 20.0326 29.0974 20.385 29.435 20.8191C29.8722 21.2855 29.9488 21.3228 30.1825 21.3228C30.4161 21.3228 30.4927 21.2855 30.93 20.8191C31.2632 20.3801 31.6934 20.0241 32.1871 19.779C32.6808 19.5339 33.2245 19.4063 33.7756 19.4062C34.3268 19.4062 34.8705 19.5336 35.3642 19.7786C35.858 20.0236 36.2884 20.3795 36.6217 20.8184Z",
    fill: "url(#paint4_linear_0_3687)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87167 20.8184C8.29142 21.2663 8.37565 21.3228 8.62132 21.3228C8.86699 21.3228 8.95195 21.2663 9.37235 20.8181C9.71027 20.3841 10.1416 20.0319 10.6344 19.7874C11.1271 19.543 11.6686 19.4127 12.2186 19.4062C12.7142 19.4003 13.205 19.5037 13.6561 19.7091V16.0459C13.6604 14.7826 13.975 13.5398 14.5721 12.4265C12.1955 6.35237 9.2378 2.37143 7.16578 2.92659C4.59719 3.61487 4.32672 11.0117 6.4691 19.7122C7.0054 19.9842 7.48218 20.3603 7.87167 20.8184ZM11.8543 12.6103C12.0349 12.6714 12.1838 12.8017 12.2683 12.9725C12.3528 13.1434 12.366 13.3408 12.3049 13.5214L10.6435 18.4308C10.6141 18.5212 10.567 18.6049 10.505 18.6769C10.443 18.749 10.3673 18.8081 10.2824 18.8507C10.1974 18.8933 10.1048 18.9187 10.01 18.9252C9.91514 18.9318 9.81994 18.9196 9.72988 18.8891C9.63983 18.8587 9.55671 18.8106 9.48533 18.7478C9.41396 18.6851 9.35576 18.6087 9.31409 18.5233C9.27242 18.4378 9.24811 18.345 9.24258 18.2501C9.23705 18.1552 9.2504 18.0601 9.28185 17.9704L10.9432 13.0609C11.0044 12.8804 11.1347 12.7316 11.3056 12.6471C11.4764 12.5626 11.6738 12.5494 11.8543 12.6103ZM7.60781 12.441L9.26813 7.53148C9.33074 7.35291 9.46126 7.20624 9.63134 7.12329C9.80142 7.04035 9.99736 7.02783 10.1766 7.08844C10.3559 7.14906 10.504 7.27792 10.5888 7.44706C10.6737 7.61621 10.6884 7.81199 10.6298 7.99191L8.96985 12.9016C8.9404 12.9919 8.89332 13.0756 8.83133 13.1477C8.76934 13.2197 8.69366 13.2788 8.60869 13.3214C8.52372 13.364 8.43113 13.3894 8.3363 13.396C8.24146 13.4026 8.14626 13.3903 8.0562 13.3598C7.96615 13.3294 7.88303 13.2814 7.81165 13.2186C7.74028 13.1558 7.68208 13.0794 7.64041 12.994C7.59874 12.9086 7.57443 12.8157 7.5689 12.7208C7.56337 12.6259 7.57636 12.5307 7.60781 12.441Z",
    fill: "url(#paint5_linear_0_3687)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3687",
    x1: 19.0778,
    y1: 4.10073,
    x2: 24.6759,
    y2: 5.12003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_3687",
    x1: 6.9272,
    y1: 18.6554,
    x2: 34.9162,
    y2: 21.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_3687",
    x1: 34.9337,
    y1: 18.6554,
    x2: 41.4441,
    y2: 18.7846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_3687",
    x1: 15.8594,
    y1: 6.58855,
    x2: 27.1673,
    y2: 7.23765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_3687",
    x1: 25.2676,
    y1: 8.94009,
    x2: 39.7713,
    y2: 10.2163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_3687",
    x1: 5.6798,
    y1: 1.06323,
    x2: 15.2636,
    y2: 1.40163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrocery);
export default __webpack_public_path__ + "static/media/grocery.d86f342c87ca0430f0c6710cc2279c3a.svg";
export { ForwardRef as ReactComponent };